export default __webpack_public_path__ + "static/personalised-ecbd0cb0ed42ccb8bd7a69d6b32e0499.png";